import { Loading } from 'element-ui';

// 保存当前的 Loading 实例
let loadingInstance = null;
const elementLoading  = {
  /**
   * 显示 Loading
   * @param {Object} options - Element UI Loading 配置项
   * @returns {Object} Loading 实例
   */
  async show(options = {}) {
    // 如果已有 Loading 实例，先关闭
    if (!loadingInstance) {
        // 合并默认配置和传入配置
        const defaultOptions = {
            fullscreen: true,
            lock: true,
            text: '数据加载中...',
            background: 'rgba(0, 0, 0, 0.5)',
            spinner: 'el-icon-loading',
            customClass: 'custom-loading',
            target:'body'
        };
        // 创建新的 Loading 实例
        loadingInstance = Loading.service({
        ...defaultOptions,
        ...options
        });
    }
    
    return loadingInstance;
  },
  
  /**
   * 隐藏 Loading
   */
  async hide() {
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
  },
  
  /**
   * 获取当前 Loading 实例
   * @returns {Object|null}
   */
  getInstance() {
    return loadingInstance;
  }
};
// 暴露实例方法
export default elementLoading;


// WEBPACK FOOTER //
// ./src/utils/loading.js